import type * as React from 'react';
import { Info } from 'lucide-react';

import type { CreateSixStep } from '@/types/create-six.types';
import StepSixInfo from '@/components/organism/CreateSix/steps/StepSixInfo/StepSixInfo';
import StepOwners from '@/components/organism/CreateSix/steps/StepOwners/StepOwners';
import StepInternalParticipants from '@/components/organism/CreateSix/steps/StepInternalParticipants/StepInternalParticipants';
import StepExternalInvitations from '@/components/organism/CreateSix/steps/StepExternal/StepExternalInvitations';
import CreateSixReviewStep from '@/components/organism/CreateSix/steps/CreateSixReviewStep';

export const STEP_CONFIG: Record<
  CreateSixStep,
  {
    component: React.FC<{ onClose: () => void }>;
    title: string;
    iconTooltip?: string;
    infoIcon?: React.ComponentType<{ className?: string }>;
  }
> = {
  Basics: {
    component: StepSixInfo,
    title: 'Basics',
    iconTooltip: 'Enter SIX name and description.',
    infoIcon: Info,
  },
  Owners: {
    component: StepOwners,
    title: 'Owners',
    iconTooltip: 'Owners can manage this SIX.',
    infoIcon: Info,
  },
  Members: {
    component: StepInternalParticipants,
    title: 'Members',
    iconTooltip: 'Select internal users as members.',
    infoIcon: Info,
  },
  External: {
    component: StepExternalInvitations,
    title: 'External invitations',
    iconTooltip: 'Invite external users as members.',
    infoIcon: Info,
  },
  Review: {
    component: CreateSixReviewStep,
    title: 'Review',
    iconTooltip: 'Review your SIX configuration before creating it.',
    infoIcon: Info,
  },
};

export const getStepConfig = (step: CreateSixStep) => STEP_CONFIG[step];
